import React, { useState, useEffect } from 'react';
import './login.css';
import Footer from '../../components/footer/Footer';

const API_BASE = process.env.REACT_APP_API_BASE;

const Login = () => {
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  // Verifica se já está logado e redireciona automaticamente
  useEffect(() => {
    const verificarSessao = async () => {
      try {
        const res = await fetch(`${API_BASE}/check-progresso.php`, {
          credentials: 'include'
        });
        const json = await res.json();

        if (json.proxima_etapa === 'genero') {
          window.location.href = '/introducao';
        } else if (json.proxima_etapa) {
          window.location.href = '/quiz';
        } else if (json.proxima_etapa === null) {
          window.location.href = '/painel';
        }
      } catch (error) {
        // Sessão não existente
      }
    };

    verificarSessao();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/login.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ login, senha })
      });

      const data = await response.json();

      if (data.status === 'sucesso') {
        const progresso = await fetch(`${API_BASE}/check-progresso.php`, {
          credentials: 'include'
        });

        const json = await progresso.json();

        if (json.proxima_etapa === 'genero') {
          window.location.href = '/introducao';
        } else if (json.proxima_etapa) {
          window.location.href = '/quiz';
        } else {
          window.location.href = '/painel';
        }
      } else {
        setErro(data.mensagem || 'Erro ao fazer login.');
      }
    } catch (error) {
      setErro('Erro ao conectar com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="login-background"
        style={{
          backgroundImage: "url('/assets/loginimage.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '100vh',
          position: 'relative'
        }}
      >
        <div className="login-overlay"></div>

        <div className="login-container">
          <div className="login-form">
            <img
              src="/assets/logo1.png"
              alt="Logo NutriFitMe"
              className="login-logo"
            />

            <h2 className="login-title">Acesse sua conta</h2>

            <form onSubmit={handleLogin}>
              <input
                type="text"
                placeholder="Seu e-mail ou CPF"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                required
              />

              <input
                type="password"
                placeholder="Sua senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
              />

              <button type="submit" disabled={loading}>
                {loading ? 'Entrando...' : 'Entrar'}
              </button>

              {/* 🔐 Esqueceu a senha */}
              <a href="/redefinir-senha" className="login-forgot">
                Esqueceu a senha?
              </a>

              {erro && <p className="login-error">{erro}</p>}
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Login;
